import React from 'react';
import { features, coverImage } from '../data/landing';
export function ProductSection() {
  return <section className="bg-cream py-14 md:py-28" data-id="element-154" data-mp="2v5ep3aezbzz">
      <div className="mx-auto grid max-w-6xl gap-10 px-5 md:gap-14 md:px-8 lg:grid-cols-[0.85fr_1.15fr] lg:gap-20" data-id="element-155" data-mp="2sav1dz85v7m">
        <div className="text-center lg:sticky lg:top-10 lg:self-start lg:text-left" data-id="element-156" data-mp="csjv52wc80sa">
          <h2 className="font-serif text-[1.9rem] font-semibold leading-tight text-ink sm:text-4xl md:text-5xl" data-id="element-157" data-mp="cqqklcilswf0">
            Descubrí una nueva forma de acercarte a los Salmos
          </h2>
          <p className="mt-5 text-[15px] leading-relaxed text-ink/80 sm:text-lg md:mt-6" data-id="element-158" data-mp="mkftmf2c5sx1">
            <strong className="text-ink" data-id="element-159" data-mp="10hcs92op4eoh">El Poder de los Salmos</strong> es un ebook cristiano pensado para acompañarte
            en tu búsqueda de comprensión, inspiración y crecimiento espiritual.
          </p>
          <p className="mt-3 text-[15px] leading-relaxed text-muted sm:text-lg md:mt-4" data-id="element-160" data-mp="32bllcocplwvs">
            Un recurso digital para que puedas dedicar tiempo a las Escrituras, reflexionar sobre sus enseñanzas y crear
            tus propios momentos de conexión con Dios.
          </p>
          <img src={coverImage} alt="" className="mt-10 hidden w-56 rounded-xl shadow-[0_20px_50px_-20px_rgba(43,33,24,0.45)] lg:block" data-id="element-161" data-mp="1bpfl1ymykoq" />
        </div>

        <div data-id="element-162" data-mp="a52h2sarmumf">
          <h3 className="font-serif text-2xl font-semibold text-ink sm:text-3xl" data-id="element-163" data-mp="a5lym7wi7gzx">¿Qué vas a encontrar?</h3>
          <ul className="mt-4 divide-y divide-line border-y border-line md:mt-6" data-id="element-164" data-mp="f4yhyio625xr">
            {features.map(({
            icon: Icon,
            title,
            text
          }) => <li key={title} className="flex gap-4 py-5 sm:gap-5 md:py-7" data-id="element-165" data-mp="p0i96rrscgg6">
                <Icon className="mt-0.5 h-5 w-5 shrink-0 text-gold sm:mt-1 sm:h-6 sm:w-6" aria-hidden="true" data-id="element-166" data-mp="t23ki8oo8mo9" />
                <div data-id="element-167" data-mp="2qsn3ub0o5rul">
                  <h4 className="font-serif text-xl font-semibold leading-tight text-ink sm:text-2xl" data-id="element-168" data-mp="2qtg9t9rt0dbo">{title}</h4>
                  <p className="mt-1.5 text-sm leading-relaxed text-muted sm:mt-2 sm:text-base" data-id="element-169" data-mp="2uu8hvzoxwc6d">{text}</p>
                </div>
              </li>)}
          </ul>
          <p className="mt-8 text-center font-serif text-xl italic leading-snug text-gold-dark sm:text-2xl md:mt-10 lg:text-left" data-id="element-170" data-mp="3t6kwuaimgeiy">
            No se trata solamente de leer más, sino de dedicar tiempo a comprender, reflexionar y poner en práctica
            aquello que aprendés.
          </p>
        </div>
      </div>
    </section>;
}